import '../scss/site.scss';
import axios from 'axios';

// Bootstrap 5 JS
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// HTMX
import 'htmx.org';

// Alpine.js
import Alpine from 'alpinejs';
import './components/sliders';
import './components/charts';
import './components/maps';
import './components/star-rating';
import './components/toasts';
import './dom';

Alpine.store('ui', {
    navOpen: false,
    searchOpen: false,
    accountSidebarOpen: false,
    filterOpen: false,

    toggleSearch() {
        this.searchOpen = !this.searchOpen;
        document.documentElement.classList.toggle('overflow-hidden', this.searchOpen);
        document.body.classList.toggle('overflow-hidden', this.searchOpen);
    },
    closeSearch() {
        this.searchOpen = false;
        document.documentElement.classList.remove('overflow-hidden');
        document.body.classList.remove('overflow-hidden');
    },
});

window.Alpine = Alpine;
Alpine.start();

// Re-initialise Alpine on content swapped in by htmx (e.g. cart aside)
document.body.addEventListener('htmx:afterSwap', (event) => {
    const target = event.detail?.elt;
    if (target && window.Alpine?.initTree) {
        window.Alpine.initTree(target);
    }

    // Scroll back to top when paginating the product grid
    const requester = event.detail?.requestConfig?.elt;
    if (requester && requester.closest('.pagination')) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
});

// Axios (keep for any remaining AJAX needs)
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
